import { Col, Form, Grid } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  CalendarSelector,
  CountDropdown,
  ResortDropdown,
  SessionTypeSelector,
  SkillSelector,
} from "../../../../../../components";
import { PanelDateType } from "../../../../../../components/CalendarSelector/data";
import { InputRequired } from "../../../../../../validations/validations";
import { FilterProps } from "../../data";

const FullFilter: React.FC<FilterProps> = ({
  form,
  params,
  setParams,
  showHalfDaySelector,
  setShowHalfDaySelector,
  studentLimit,
  setStudentLimit,
}) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [panelDate, setPanelDate] = useState<PanelDateType>();

  return (
    <>
      <Col span={screens.lg ? (showHalfDaySelector ? 4 : 5) : 24}>
        <Form.Item name={"start_date"} hidden />
        <Form.Item name={"end_date"} hidden />
        <Form.Item
          name={"date"}
          label={screens.lg ? t("home.searchbar.date.title") : ""}
          style={{ marginBottom: 0 }}
          rules={[InputRequired(t, "home.searchbar.date.title")]}
        >
          <CalendarSelector
            setPanelDate={setPanelDate}
            schedule={[]}
            form={form}
            defaultOpen={false}
            needDisableDate={false}
          />
        </Form.Item>
      </Col>
      <Col span={screens.lg ? (showHalfDaySelector ? 4 : 5) : 12}>
        <Form.Item
          style={{ marginBottom: 0 }}
          name={"skill_type"}
          label={screens.lg ? t("normal.skill.title") : ""}
          rules={[InputRequired(t, "normal.skill.title")]}
        >
          <SkillSelector form={form} />
        </Form.Item>
      </Col>
      <Col span={screens.lg ? (showHalfDaySelector ? 4 : 5) : 12}>
        <Form.Item
          name={"count"}
          required
          label={screens.lg ? t("normal.count.title") : ""}
          style={{ marginBottom: 0 }}
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (
                  Number(getFieldValue("adults")) === 0 &&
                  Number(getFieldValue("kids")) === 0
                )
                  return Promise.reject(
                    new Error(
                      t("form.required", { name: t("normal.count.title") })
                    )
                  );
                return Promise.resolve();
              },
            }),
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (
                  Number(getFieldValue("adults")) +
                    Number(getFieldValue("kids")) >
                  studentLimit
                ) {
                  return Promise.reject(
                    new Error(
                      t("home.filter.count.error", { limit: studentLimit })
                    )
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <CountDropdown
            form={form}
            params={params}
            setParams={setParams}
            studentLimit={studentLimit}
          />
        </Form.Item>
        <Form.Item hidden name={"adults"} />
        <Form.Item hidden name={"kids"} />
      </Col>
      <Col
        span={
          screens.lg
            ? showHalfDaySelector
              ? 4
              : 5
            : showHalfDaySelector
            ? 12
            : 24
        }
      >
        <Form.Item
          style={{ marginBottom: 0 }}
          name={"locations"}
          label={screens.lg ? t("home.searchbar.resort.title") : ""}
        >
          <ResortDropdown
            form={form}
            setShowHalfDaySelector={setShowHalfDaySelector}
            setStudentLimit={setStudentLimit}
          />
        </Form.Item>
      </Col>
      {showHalfDaySelector && (
        <Col span={screens.lg ? 4 : 12}>
          <Form.Item
            style={{ marginBottom: 0 }}
            name={"session_type"}
            label={screens.lg ? t("normal.sessionType") : ""}
            rules={[InputRequired(t, "normal.sessionType")]}
          >
            <SessionTypeSelector form={form} />
          </Form.Item>
        </Col>
      )}
    </>
  );
};

export default FullFilter;
